import { Alert, Button, CircularProgress, InputBase, Snackbar } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import ResetLinkSentModal from "../modals/ResetLinkSentModal";

const Account = () => {
  let user_data = JSON.parse(localStorage.getItem("user"));
  const [errorMsg, setErrormsg] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [successMsg, setSuccessMsg] = useState(null)
  const [loader, setLoader] = useState(false);
    const [user, setUser] = useState({
      user_id: user_data.userId.S, // Replace with actual user ID
      email: user_data.email.S,
      first_name : user_data.fName.S,
      last_name: user_data.lName.S,
      google : user_data?.registeredFromGoogle?.BOOL || false
    })

    async function updateUser(){
      setLoader(true);
       let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                  userId: JSON.parse(localStorage.getItem('user')).userId.S
              });
              
              if (check.status ===  200) {
                const user___ = check.data.user;
                
          
                if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                  try {
              
                    const orgId = JSON.parse(localStorage.getItem("organization")).orgId.S;
                    let user_data = await axios
                    .post(
                      process.env.REACT_APP_BACKEND_URL + "user/update-user",
                      { ...user, organization_id: orgId }
                    )
                
                    localStorage.setItem('user', JSON.stringify(user_data.data.updatedUser))
            
                    setSuccessMsg('User details successfully updated')
                    setTimeout(() => {
                      setSuccessMsg(null)
                    }, 3000);
                    
              
                    setLoader(false);
              
                  } catch (error) {
                    if (error.response && error.response.data) {
                      setErrormsg(error.response.data.message);
                    }
                    setLoader(false);
                  }
                    
                }else{
                  window.location.reload()
                }
      
              }
    }


    async function sendResetLink(){
     
      setLoader(true);
      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
        userId: JSON.parse(localStorage.getItem('user')).userId.S
    });
    
    if (check.status ===  200) {
      const user___ = check.data.user;
      

      if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
          
        try {
    
          let response = await axios
          .post(
            process.env.REACT_APP_BACKEND_URL + "email/send-reset-link",
            {
              email : user.email,
              organization_id:  JSON.parse(localStorage.getItem("organization")).orgId.S,
              toName: user.first_name +' '+user.last_name ,
              user_id : user.user_id
               
            }
          )
      
          setOpenSuccessModal(true)
    
          setLoader(false);
    
        } catch (error) {
          if (error.response && error.response.data) {
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }
      }else{
        window.location.reload()
      }

    }
    }
  return (
    <div className=" flex flex-col h-[100%] lg:px-0 py-4 lg:py-0 px-3  ">
       <ResetLinkSentModal open={openSuccessModal} setOpen={setOpenSuccessModal} email={user.email}/>
       <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={!!errorMsg}
        autoHideDuration={6000}
        onClose={() => setErrormsg(null)}
      >
        <Alert onClose={() => setErrormsg(null)} severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {successMsg && (
         <Alert color='success' sx={{mb: 4}}>
                    <div className=" text-black-600 text-[14px] ">
                 {successMsg}
                </div>
                  </Alert>
      )}

      {loader && (
        <div className="flex justify-center">
          <CircularProgress size={"3rem"} sx={{ color: "blue" }} />
        </div>
      )}
      <div className="flex items-center lg:w-[380px] space-x-10 mb-5">
     
        <div className="lg:text-[14px] text-[13px] font-semibold my-auto">Email</div>

        <div className="w-full">
          <InputBase
          readOnly
          value={user.email}
          onChange={(e)=> {
            setUser({...user, email: e.target.value})
          }}
            
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              fontSize: {lg:"14px", xs:"13px"},
              borderRadius: "10px",
              height: "42px",
            }}
          />
        </div>
      </div>

      <div className="flex items-center lg:w-[380px] space-x-9 ">
        <div className="lg:text-[14px] text-[13px] font-semibold my-auto">Name</div>

        <div className="w-full flex space-x-2">
          <InputBase
            value={user.first_name}
            onChange={(e)=> {
              setUser({...user, first_name: e.target.value})
            }}
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              fontSize: {lg:"14px", xs:"13px"},
              borderRadius: "10px",
              height: "42px",
            }}
          />

          <InputBase
             value={user.last_name}
             onChange={(e)=> {
               setUser({...user, last_name: e.target.value})
             }}
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              fontSize: {lg:"14px", xs:"13px"},
              borderRadius: "10px",
              height: "42px",
            }}
          />
        </div>
      </div>


     {user?.google ? (
<Alert color="warning" sx={{my:{lg:2, xs:2}, width:{lg:"380px", xs: '100%'}}} >
<div className="text-[14px] "> This account uses Google login </div>
</Alert>
     ): (
      <div className="flex pt-5  mb-16 lg:mb-0">
      <Button
        variant="contained"
          color="primary"
          sx={{
          py: {lg:"8px", xs:'5px'},
          px: "20px",
          borderRadius: "12px",
          fontSize: {lg:{lg:"14px", xs:"13px"}, xs: '12px'},
          height:'fit'
        }}
        onClick={sendResetLink}
        disabled={loader}
      >
        {loader ? (
        <CircularProgress size={"1rem"} sx={{ color: "white" }} />
      ) : (
        "  Reset Password"
      )}
        
      </Button>
    </div>
     )}

      <div className="flex justify-end pt-5  ">
      <Button
            variant="contained"
              color="primary"
              sx={{
              py: {lg:"10px", xs:'5px'},
              px: "20px",
              borderRadius: "12px",
              fontSize: {lg:"14px", xs: '12px'},
              height:'fit'
            }}
            onClick={updateUser}
            disabled={loader}
            
          > {loader ? (
            <CircularProgress size={"1rem"} sx={{ color: "white" }} />
          ) : (
            "  Save Changes"
          )}
          </Button>
        </div>
    </div>
  );
};

export default Account;
